import { render, staticRenderFns } from "./PPMList2.vue?vue&type=template&id=3caad164&scoped=true"
import script from "./PPMList2.vue?vue&type=script&lang=ts"
export * from "./PPMList2.vue?vue&type=script&lang=ts"
import style0 from "./PPMList2.vue?vue&type=style&index=0&id=3caad164&prod&lang=css"
import style1 from "./PPMList2.vue?vue&type=style&index=1&id=3caad164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caad164",
  null
  
)

export default component.exports